/**
* 系统管理  菜单信息
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>个人中心</el-breadcrumb-item>
    </el-breadcrumb>
    <el-main  class="personalCenter">
      <el-form label-width="80px" ref="editForm" :model="editForm" :rules="rules" class="pcForm">
        <el-form-item label="用户名" prop="userName">
          <el-input size="small" auto-complete="off" placeholder="admin"></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="userName">
          <el-input size="small" auto-complete="off" placeholder="请输入登录密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="userName">
          <el-input size="small" auto-complete="off" placeholder="请输入确认密码"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名" prop="userName">
          <el-input size="small" auto-complete="off" placeholder="请输入真实姓名"></el-input>
        </el-form-item>
      </el-form>
      <div >
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-main>
  </div>
</template>

<script>
  import {
    permissionList,
    ermissionSave,
    ermissionDelete,
    roleDropDown,
    RolePermission
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        data:[],
        type:
          {
            type:''
          },
        childList:[],
        childListchild:[],
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    watch: {},

    /**
     * 创建完毕
     */

    created() {
      this.getdata()
    },

    /**
     * 里面的方法只有被调用才会执行
     */

    methods: {
      // 获取数据方法
      getdata() {
        this.loading = true

        // 获取权限列表
        permissionList(this.type)
          .then(res => {
            this.loading = false

            if (res.code !=0) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {

              //一级菜单
              this.data = [];
              for(var i=0;i<res.data.length;i++){
                //二级菜单
                this.childList=[];
                for(var j=0;j<res.data[i].childList.length;j++){

                 //三级权限
                  this.childListchild=[];
                  for(var k=0;k<res.data[i].childList[j].childList.length;k++){
                    this.childListchild({label: res.data[i].childList[j].childList[k].name})
                  }
                  this.childList.push({label: res.data[i].childList[j].name, children:this.childListchild})
                }

                this.data.push({label: res.data[i].name, children: this.childList});
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('菜单信息获取失败，请稍后再试！')
          })
      }
    }
  }
</script>

<style scoped>

  .personalCenter {
    width:100%;
    text-align:center
  }
  .pcForm{
    width:30%;
  }
</style>




// WEBPACK FOOTER //
// src/views/system/PersonalCenter.vue